import React, { Component } from "react";
import "../css/App.css";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import serviceauth from "../auth/serviceauth";
import UtilFunctions from "../UtilFunctions";
import Select from 'react-select';
import AdminUtils from "./AdminUtils";
import SuccessDialogBox from "./SuccessDialogBox";
import ErrorAlert from "./ErrorAlert";

class DeleteTerm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTerm: "",
            allTerms: [],
            toBeDeletedTerm: "",
            toBeDeletedTermLabel: "",
            modalShow: false,
            showErrorAlert:false,
            showConfirmDialog: false
        };
    }

    componentDidMount() {
        fetch(AdminUtils.getRequestObject(UtilFunctions.getTermListUrl(), "GET"))
            .then((response) => {
                if (response.status === 401) {
                    serviceauth.reauth();
                }
                return response.json();
            })
            .then(
                (termList) => {
                    this.setState({
                        currentTerm: termList.currentTerm[0].value,
                        allTerms: termList.fullList
                    });
                }
            ).catch(err => { 
                console.log(err);
                this.setState({
                    showErrorAlert:true
                });
            });
    }

    selectTermForDeletion(e) {
        //console.log("selected term for deletion:", e.value)
        this.setState({
            toBeDeletedTerm: e.value,
            toBeDeletedTermLabel: e.label
        });
    }

    showConfirmDialog(e) {
        e.preventDefault();
        
        if (!this.state.toBeDeletedTerm) {
            alert("Please select a term to delete");
            return;
        }

        this.setState({ showConfirmDialog: true });
    }

    deleteSelectedTerm() {
        this.setState({ showConfirmDialog: false });

        fetch(AdminUtils.getRequestObject(AdminUtils.getDeleteTermUrl(), "DELETE", JSON.stringify({
            term: this.state.toBeDeletedTerm
        })))
            .then((response) => {
                if (response.status === 401) {
                    serviceauth.reauth();
                }
                return response.json();
            })
            .then((responseData) => {
                if (responseData.output === 1) {
                    // console.log("Successfully deleted selected term!");
                    // Refresh the term list after successful deletion
                    this.refreshTermList();
                } else {
                    // console.log("Failed to delete selected term!");
                    this.setState({
                        showErrorAlert:true
                    });
                }
            }).catch(err => { 
                console.log(err);
                this.setState({
                    showErrorAlert:true
                });
            });
    }

    refreshTermList() {
        // Fetch the updated term list from the server with cache-busting
        const url = UtilFunctions.getTermListUrl() + '?_=' + Date.now();
        fetch(AdminUtils.getRequestObject(url, "GET"))
            .then((response) => {
                if (response.status === 401) {
                    serviceauth.reauth();
                }
                return response.json();
            })
            .then((termList) => {
                this.setState({
                    currentTerm: termList.currentTerm[0].value,
                    allTerms: termList.fullList,
                    toBeDeletedTerm: "",
                    toBeDeletedTermLabel: "",
                    modalShow: true
                });
            })
            .catch(err => { 
                console.log('Error refreshing term list:', err);
                // Still show success and clear selection even if refresh fails
                this.setState({
                    toBeDeletedTerm: "",
                    toBeDeletedTermLabel: "",
                    modalShow: true
                });
            });
    }

    render() {
        return (<Container>
                <h4 className="mb-3">
                    <mark>Terms have up to 5 min caching delay.</mark>
                </h4>
            <Form>
                <Form.Group controlId="deleteTermSelect">
                    <Form.Label>Delete Term</Form.Label>
                    <Select 
                        key={`term-select-${this.state.allTerms.length}`}
                        options={this.state.allTerms
                            .filter(term => term.value !== this.state.currentTerm)
                            .map(term => ({
                                value: term.value + ',' + term.label,
                                label: term.label
                            }))}
                        onChange={(e) => this.selectTermForDeletion(e)} 
                    />
                </Form.Group>

                <button type="button" className="btn btn-maroon mt-3 " onClick={(e) => this.showConfirmDialog(e)}>
                    Submit
                </button>
            </Form>

            {/* Confirmation Dialog */}
            <Modal 
                show={this.state.showConfirmDialog} 
                onHide={() => this.setState({ showConfirmDialog: false })}
            >
                <Modal.Header closeButton>
                    <Modal.Title>⚠️ Confirm Term Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        You are about to delete term: <strong>{this.state.toBeDeletedTermLabel}</strong>
                    </p>
                    <p className="text-danger">
                        <strong>This action cannot be undone!</strong> Are you sure you want to proceed?
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ showConfirmDialog: false })}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => this.deleteSelectedTerm()}>
                        Yes, Delete Term
                    </Button>
                </Modal.Footer>
            </Modal>

            <SuccessDialogBox
                show={this.state.modalShow}
                onHide={() => this.setState({modalShow: false})}
                successMessage="Deleted selected term successfully"
            />

            <ErrorAlert
                show={this.state.showErrorAlert}
                onHide={() => this.setState({ showErrorAlert: false })}
            />

        </Container>)
    }
}

export default DeleteTerm;